export default __webpack_public_path__ + "static/media/bagarrescreen.f01b62d7.png";